var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'view-register', { '-full-content': !!_vm.user }]},[_c('main',{staticClass:"content"},[(!_vm.user)?_c('registration-container',{staticClass:"new-register-form",attrs:{"no-heading":_vm.noHeading},on:{"success":_vm.redirect}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }